import {AuthModel, UserModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const USER_LOCAL_STORAGE_KEY = 'kt-user-react-v'
const getAuth = (): AuthModel | undefined => {
  if (typeof localStorage === 'undefined') {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue || lsValue === 'undefined') {
    return
  }

  try {
    const auth = JSON.parse(lsValue) as AuthModel
    if (auth && typeof auth === 'object' && auth.api_token) {
      // You can easily check auth_token expiration also
      return auth
    }

    // Fallback for legacy tokens stored as raw strings
    if (typeof auth === 'string') {
      return {api_token: auth} as AuthModel
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (typeof localStorage === 'undefined') {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (typeof localStorage === 'undefined') {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const getUser = (): UserModel | undefined => {
  if (typeof localStorage === 'undefined') return
  const lsValue = localStorage.getItem(USER_LOCAL_STORAGE_KEY)
  if (!lsValue) return
  try {
    return JSON.parse(lsValue) as UserModel
  } catch (error) {
    console.error('USER LOCAL STORAGE PARSE ERROR', error)
  }
}

const setUser = (user: UserModel) => {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user))
  } catch (error) {
    console.error('USER LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeUser = () => {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(USER_LOCAL_STORAGE_KEY)
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}
export {getAuth, setAuth, removeAuth, getUser, setUser, removeUser, AUTH_LOCAL_STORAGE_KEY}
